import type { StorageClassDisplayInfo } from '@/delivery-type-plugin/capabilities/maas-model-storage/storageVolume';

export interface DisplayDescriptor {
  id: string;
  group: string;
  label: string;
  value: string;
  tag?: string;
  /** 存储类行专用：结构化展示 alias/name/provisioner */
  storageClassInfo?: StorageClassDisplayInfo;
  children?: DisplayDescriptor[];
}

/** SKU 卡片展示信息行（与 product-skus DisplayConfigItem 对齐） */
export interface DisplayConfigItem {
  id: string;
  key: string;
  value: string;
  tag?: string;
}

function flattenDescriptors(descriptors: DisplayDescriptor[]): DisplayDescriptor[] {
  const result: DisplayDescriptor[] = [];
  for (const item of descriptors) {
    result.push(item);
    if (item.children?.length) {
      result.push(...flattenDescriptors(item.children));
    }
  }
  return result;
}

/** DisplayDescriptor → SKU displayConfig */
export function mapDescriptorsToDisplayConfig(descriptors: DisplayDescriptor[]): DisplayConfigItem[] {
  const res = flattenDescriptors(descriptors)?.map((item) => ({
    id: item.id,
    key: item.label,
    value: item.value,
    tag: item.tag,
  }));
  return res?.filter((item) => item.value !== undefined && item.value !== null && item.value !== '') ?? [];
}
